import { css } from '@emotion/react';
import { math } from 'polished';

import { BorderRadius } from './mixins/_border-radius.mixin';
import { MediaBreakpointUp } from './mixins/_breakpoints.mixin';


export default $ => css`
  .jumbotron {
    padding: ${$.jumbotronPadding} ${math(`${$.jumbotronPadding} * 0.5`)};
    margin-bottom: ${$.jumbotronPadding};
    color: ${$.jumbotronColor};
    background-color: ${$.jumbotronBg};
    ${new BorderRadius($.borderRadiusLg).include($)};

    ${new MediaBreakpointUp("sm").include($, css`
      padding: ${math(`${$.jumbotronPadding} * 2`)} ${$.jumbotronPadding};
    `)}
  }

  .jumbotron-fluid {
    padding-right: 0;
    padding-left: 0;
    ${new BorderRadius(0).include($)};
  }
`;
